/**
 * Panier Lasto — add-ons natifs du cart drawer (Zenith).
 *
 * Conçu pour être robuste :
 *  - toutes les mutations panier passent par une FILE sérialisée (jamais de course) ;
 *  - chaque mutation rafraîchit l'UI depuis l'état SERVEUR réel (avec fallback) ;
 *  - on ne publie pas d'évènement qui re-déclencherait le cart natif du thème
 *    (on écoute juste ses updates pour réconcilier cadeau / protection) ;
 *  - le panier flash ne vide jamais le panier au chargement pour un chrono déjà
 *    périmé, ni en mode éditeur de thème (Shopify.designMode).
 *
 * Protection livraison : ligne « produit » technique, masquée de la liste et
 * présentée comme un frais. Auto-retirée si plus aucun vrai produit au panier.
 */
(function () {
  "use strict";

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var BASE = ROOT.replace(/\/$/, "");
  var LS_KEY = "lasto_flash_start";
  var SECTIONS = ["cart-drawer", "cart-icon-bubble"];
  var DESIGN = !!(window.Shopify && Shopify.designMode);

  // Accès localStorage PROTÉGÉ (navigation privée / stockage bloqué peut throw).
  // Repli mémoire pour que le chrono fonctionne quand même dans la session.
  var memStart = null;
  function lsGet() {
    try {
      var v = localStorage.getItem(LS_KEY);
      return v !== null ? v : memStart;
    } catch (e) {
      return memStart;
    }
  }
  function lsSet(v) {
    memStart = v;
    try {
      localStorage.setItem(LS_KEY, v);
    } catch (e) {}
  }
  function lsDel() {
    memStart = null;
    try {
      localStorage.removeItem(LS_KEY);
    } catch (e) {}
  }

  /* ------------------------------- config ---------------------------------- */
  function cfg() {
    var el = document.querySelector("[data-lasto-cart-config]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* -------------------- file d'attente des mutations ----------------------- */
  var chain = Promise.resolve();
  function enqueue(fn) {
    chain = chain.then(fn).catch(function (e) {
      console.error("[lasto] cart op failed", e);
    });
    return chain;
  }

  function postJSON(path, body) {
    return fetch(BASE + path, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body || {}),
    }).then(function (r) {
      return r
        .json()
        .catch(function () {
          return {};
        })
        .then(function (j) {
          return { ok: r.ok, data: j };
        });
    });
  }

  function getCart() {
    return fetch(BASE + "/cart.js", { headers: { Accept: "application/json" } }).then(
      function (r) {
        return r.json();
      }
    );
  }

  function fetchSections() {
    return fetch(
      window.location.pathname + "?sections=" + SECTIONS.join(","),
      { headers: { Accept: "application/json" } }
    ).then(function (r) {
      return r.json();
    });
  }

  /* ---------------------- rafraîchissement de l'UI ------------------------- */
  function applySections(sections) {
    if (!sections) return;
    if (sections["cart-drawer"]) {
      var doc = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
      var ni = doc.querySelector(".cart-drawer__inner");
      var ci = document.querySelector("#CartDrawer .cart-drawer__inner");
      if (ni && ci) ci.innerHTML = ni.innerHTML;
      var drawer = document.querySelector("cart-drawer");
      if (drawer) {
        drawer.classList.toggle("is-empty", doc.querySelectorAll(".cart-item").length === 0);
      }
    }
    if (sections["cart-icon-bubble"]) {
      var bdoc = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html");
      var nb = bdoc.querySelector("#cart-icon-bubble");
      var cb = document.querySelector("#cart-icon-bubble");
      if (nb && cb) cb.innerHTML = nb.innerHTML;
    }
    flashRender();
  }

  // Mutation panier (add/change) → rafraîchit l'UI + le compteur depuis le serveur.
  function mutate(path, body) {
    body = body || {};
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return postJSON(path, body)
      .then(function (res) {
        if (res.data && res.data.sections) {
          applySections(res.data.sections);
          return res;
        }
        // Échec (ex. variante indisponible) → resynchronise l'UI sur l'état réel.
        return fetchSections().then(function (s) {
          applySections(s);
          return res;
        });
      })
      .then(function (res) {
        return refreshCount().then(function () {
          return res;
        });
      });
  }

  function clearCart() {
    return postJSON("/cart/clear.js", {}).then(function () {
      knownCount = 0;
      lsDel();
      if (document.body.classList.contains("template-cart")) {
        window.location.reload();
        return new Promise(function () {}); // page en cours de navigation
      }
      return fetchSections().then(applySections);
    });
  }

  /* ------------- réconciliation cadeau + nettoyage protection -------------- */
  function reconcile() {
    var c = cfg();
    if (!c) return Promise.resolve();
    // Réconciliation seulement sur les pages avec le drawer (la page /cart a son
    // propre rendu ; on évite des mutations non répercutées à l'écran).
    if (!document.querySelector("cart-drawer")) return Promise.resolve();
    return getCart().then(function (cart) {
      var protectId = c.protect && c.protect.enabled ? Number(c.protect.variantId) : 0;
      var giftId = c.gift && c.gift.enabled ? Number(c.gift.variantId) : 0;
      var lines = cart.items || [];

      var protectLine = protectId && lines.find(function (i) { return i.variant_id === protectId; });
      var giftLine = giftId && lines.find(function (i) { return i.variant_id === giftId; });

      var isAddon = function (i) {
        return (protectId && i.variant_id === protectId) || (giftId && i.variant_id === giftId);
      };
      var realCount = lines.reduce(function (n, i) { return isAddon(i) ? n : n + i.quantity; }, 0);
      var eligible = lines.reduce(function (s, i) { return isAddon(i) ? s : s + i.final_line_price; }, 0);

      // 1) Protection sans aucun vrai produit → on la retire.
      if (protectLine && realCount === 0) {
        return mutate("/cart/change.js", { id: String(protectId), quantity: 0 });
      }
      // 2) Cadeau offert selon le seuil.
      if (giftId) {
        var qualifies = realCount > 0 && eligible >= c.gift.thresholdCents;
        if (qualifies && !giftLine) {
          return mutate("/cart/add.js", { items: [{ id: giftId, quantity: 1 }] });
        }
        if (!qualifies && giftLine) {
          return mutate("/cart/change.js", { id: String(giftId), quantity: 0 });
        }
      }
      return null;
    });
  }

  /* ============================ PANIER FLASH =============================== */
  var flashTimer = null;
  var expiring = false;
  var toastEl = null;
  var toastDismissed = false;
  var knownCount = 0; // articles réels (hors protection/cadeau) — source: /cart.js
  var firstCount = true;
  var tick = 0;

  function fmt(sec) {
    var m = Math.floor(sec / 60);
    var s = sec % 60;
    return (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
  }

  /* ------------- alerte flottante avant expiration (toast) ----------------- */
  function ensureToast(accent) {
    if (toastEl) return toastEl;
    toastEl = document.createElement("div");
    toastEl.className = "lasto-flash-toast";
    toastEl.setAttribute("role", "status");
    if (accent) toastEl.style.setProperty("--lasto-accent", accent);
    toastEl.innerHTML =
      '<span class="lasto-flash-toast__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2 2"/><path d="M5 3 2 6"/><path d="m22 6-3-3"/></svg>' +
      "</span>" +
      '<span class="lasto-flash-toast__text"></span>' +
      '<button type="button" class="lasto-flash-toast__close" aria-label="Fermer">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="14" height="14"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
      "</button>";
    toastEl.addEventListener("click", function (e) {
      if (e.target.closest(".lasto-flash-toast__close")) {
        e.stopPropagation();
        toastDismissed = true;
        hideToast();
        return;
      }
      var d = document.querySelector("cart-drawer");
      if (d && typeof d.open === "function") d.open();
    });
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function showToast(c, left) {
    var t = ensureToast(c.flash.color);
    var msg = (c.flash.warnText || "Ton panier expire dans [temps]").replace(
      "[temps]",
      fmt(left)
    );
    t.querySelector(".lasto-flash-toast__text").textContent = msg;
    t.classList.add("is-visible");
  }

  function hideToast() {
    if (toastEl) toastEl.classList.remove("is-visible");
  }

  // Compte les VRAIS articles (hors protection / cadeau) depuis un objet cart.
  function realCount(cart) {
    var c = cfg();
    var protectId = c && c.protect && c.protect.enabled ? Number(c.protect.variantId) : 0;
    var giftId = c && c.gift && c.gift.enabled ? Number(c.gift.variantId) : 0;
    return (cart.items || []).reduce(function (n, i) {
      return i.variant_id === protectId || i.variant_id === giftId ? n : n + i.quantity;
    }, 0);
  }

  // CONTRÔLEUR. Source de vérité = /cart.js (jamais le DOM, qui fluctue).
  // Il VÉRIFIE l'état du panier et démarre / coupe le chrono, mais n'INFLUE JAMAIS
  // sur un décompte déjà en cours (aucune réinitialisation sur ajout). Un nouveau
  // chrono ne démarre que si le panier passe de vide à non-vide (aucun chrono),
  // ou si le chrono existant est déjà périmé (laissé d'une session précédente).
  function refreshCount() {
    return getCart()
      .then(function (cart) {
        var c = cfg();
        knownCount = realCount(cart);

        if (!knownCount) {
          // Panier vide → on coupe le chrono.
          lsDel();
        } else if (c && c.flash && c.flash.enabled) {
          var start = parseInt(lsGet(), 10);
          var hasStart = start && !isNaN(start);
          var totalMs = (c.flash.minutes || 15) * 60000;
          if (!hasStart) {
            // Aucun chrono (1er article) → on en démarre un.
            lsSet(String(Date.now()));
            toastDismissed = false;
          } else if (firstCount && Date.now() - start >= totalMs) {
            // SEULEMENT au 1er chargement : chrono périmé d'une session précédente
            // → on repart neuf (sans vider le panier rétroactivement).
            lsSet(String(Date.now()));
            toastDismissed = false;
          }
          // Sinon : chrono en cours (ou expiré en session active) → on n'y touche
          // PAS. flashRender gère l'expiration (vidage). Le contrôleur n'influe jamais.
        }
        firstCount = false;
        flashRender();
        return knownCount;
      })
      .catch(function () {
        firstCount = false;
      });
  }

  // Met à jour les deux affichages : timer du drawer + timer du header.
  function paintTimers(left) {
    var txt = fmt(Math.max(0, left));
    var urgent = left <= 60;
    var dEl = document.querySelector("[data-lasto-flash]");
    var dT = dEl && dEl.querySelector(".lasto-flash__time");
    if (dT) {
      dT.textContent = txt;
      dEl.classList.toggle("is-urgent", urgent);
    }
    var hEl = document.querySelector("[data-lasto-header-timer]");
    if (hEl) {
      var hT = hEl.querySelector(".lasto-header-timer__time");
      if (hT) hT.textContent = txt;
      hEl.hidden = false;
      hEl.classList.toggle("is-urgent", urgent);
    }
  }

  function hideHeaderTimer() {
    var h = document.querySelector("[data-lasto-header-timer]");
    if (h) h.hidden = true;
  }

  function showExpired(msg) {
    var inner = document.querySelector("#CartDrawer .cart-drawer__inner");
    if (!inner || !msg) return;
    var old = inner.querySelector(".lasto-flash-notice");
    if (old) old.remove();
    var n = document.createElement("div");
    n.className = "lasto-flash-notice";
    n.setAttribute("role", "status");
    n.textContent = msg;
    inner.insertBefore(n, inner.firstChild);
  }

  // Affichage pur, appelé chaque seconde. Ne lit AUCUN compteur (utilise knownCount,
  // tenu à jour par refreshCount sur événements) → pas de rebond du chrono.
  function flashRender() {
    var c = cfg();
    if (!c || !c.flash.enabled || !knownCount) {
      hideHeaderTimer();
      hideToast();
      return;
    }

    // Lecture pure : si aucun chrono, on masque (c'est le CONTRÔLEUR qui le crée,
    // jamais l'affichage) → impossible de réinitialiser depuis ici.
    var start = parseInt(lsGet(), 10);
    if (!start || isNaN(start)) {
      hideHeaderTimer();
      hideToast();
      return;
    }

    var left = (c.flash.minutes || 15) * 60 - Math.floor((Date.now() - start) / 1000);

    if (left <= 0) {
      hideToast();
      hideHeaderTimer();
      if (c.flash.clearOnExpire && !DESIGN && !expiring) {
        expiring = true;
        lsDel();
        toastDismissed = false;
        knownCount = 0;
        enqueue(clearCart)
          .then(function () {
            showExpired(c.flash.expiredMessage);
          })
          .then(function () {
            expiring = false;
          });
      } else {
        paintTimers(0);
      }
      return;
    }

    paintTimers(left);

    // Alerte flottante : dans la fenêtre d'avertissement, drawer fermé, non rejetée.
    var drawerOpen = !!document.querySelector("cart-drawer.modal--open");
    if (
      c.flash.warnEnabled &&
      !toastDismissed &&
      !drawerOpen &&
      left <= (c.flash.warnSeconds || 60)
    ) {
      showToast(c, left);
    } else {
      hideToast();
    }
  }

  /* ======================== PROTECTION (toggle) =========================== */
  function onProtectChange(e) {
    var input = e.target && e.target.closest && e.target.closest("[data-lasto-protect]");
    if (!input) return;
    var vid = input.dataset.variantId;
    var add = input.checked;
    var card = input.closest(".lasto-protect");
    if (card) card.classList.add("is-loading");

    enqueue(function () {
      return add
        ? mutate("/cart/add.js", { items: [{ id: Number(vid), quantity: 1 }] })
        : mutate("/cart/change.js", { id: String(vid), quantity: 0 });
    });
  }

  /* ================================ INIT ================================== */
  function init() {
    // Garde au niveau window : empêche un 2e intervalle si le script est chargé
    // deux fois (sinon le décompte saute « 2 secondes par 2 secondes »).
    if (window.__lastoCartBooted) return;
    window.__lastoCartBooted = true;

    // État initial du compteur depuis le serveur, puis tic d'affichage chaque seconde
    // avec un filet de sécurité : re-sync /cart.js toutes les ~10 s (auto-correction
    // si un événement a été manqué — ex. vidage dans un autre onglet).
    refreshCount();
    flashTimer = setInterval(function () {
      flashRender();
      tick = (tick + 1) % 10;
      if (tick === 0) refreshCount();
    }, 1000);

    // Toggle protection (délégation — survit aux re-render du drawer).
    document.addEventListener("change", onProtectChange);

    // Clic sur le timer du header → ouvre le drawer (sinon va vers /cart).
    document.addEventListener("click", function (e) {
      var timer = e.target && e.target.closest && e.target.closest("[data-lasto-header-timer]");
      if (!timer) return;
      var d = document.querySelector("cart-drawer");
      if (d && typeof d.open === "function") {
        e.preventDefault();
        d.open();
      }
    });

    // Retour sur l'onglet → resynchronise (panier modifié ailleurs entre-temps).
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) refreshCount();
    });

    // Synchro inter-onglets : le chrono/panier a changé dans un autre onglet.
    window.addEventListener("storage", function (e) {
      if (e.key === LS_KEY) {
        memStart = e.newValue;
        refreshCount();
      }
    });

    // Updates natifs du panier (qty, suppression…) → recompter + réconcilier.
    if (typeof PUB_SUB_EVENTS !== "undefined" && typeof subscribe === "function") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === "lasto-cart-addons") return;
        refreshCount();
        enqueue(reconcile);
      });
    }

    // Passe initiale (cadeau / nettoyage protection).
    enqueue(reconcile);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
